module.exports = __webpack_public_path__ + "static/media/crifBusinessEliteGRBadge.2a3077f1.svg";